import { ChatOperational } from '@carbon/icons-react';
import * as React from 'react';

import { useVoiceboxConversation } from 'bones/components/molecules/Voicebox/context/VoiceboxConversation';
import { useVoiceboxPanelData } from 'bones/components/molecules/Voicebox/context/VoiceboxPanelData';
import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { VoiceboxRequestMessage } from 'bones/constants/voicebox/message';
import {
  Breadcrumb,
  BreadcrumbItem,
} from 'bones/design-system/components/breadcrumb/Breadcrumb';

export const VoiceboxPanelBreadcrumb: React.VFC = () => {
  const { testIds } = useVoiceboxSchema();
  const { messages } = useVoiceboxConversation();
  const { panelHistory, setPanelHistory, getLabelOrLocalName } =
    useVoiceboxPanelData();

  const items = React.useMemo(
    () =>
      panelHistory && panelHistory.length > 1
        ? panelHistory.reduce<BreadcrumbItem[]>((acc, panel, panelIdx) => {
            const id = `${panel.messageId}-${panel.iri}-${panelIdx}`;
            const onClick = () => {
              setPanelHistory(panelHistory.slice(0, panelIdx + 1));
            };

            if (panel.iri) {
              const text = getLabelOrLocalName(panel.iri);
              acc.push({
                id,
                onClick,
                text,
                testId: testIds.panel.breadcrumb.item(panel.iri, panelIdx),
              });
            } else {
              const messageIdx = messages.findIndex(
                (message) => message.messageId === panel.messageId
              );
              const prevRequestMessage = messages
                .slice(0, messageIdx)
                .reverse()
                .find((message): message is VoiceboxRequestMessage =>
                  Boolean(message.isRequest)
                );

              // istanbul ignore else
              if (prevRequestMessage?.query) {
                acc.push({
                  id,
                  leftIcon: ChatOperational,
                  menuText: prevRequestMessage.query,
                  onClick,
                  text: '',
                  testId: testIds.panel.breadcrumb.item(
                    panel.messageId,
                    panelIdx
                  ),
                });
              }
            }

            return acc;
          }, [])
        : [],
    [getLabelOrLocalName, messages, panelHistory, setPanelHistory, testIds]
  );

  if (!items.length) {
    return null;
  }

  return (
    <Breadcrumb
      items={items}
      menuProps={{ testId: testIds.panel.breadcrumb.menu }}
      showFirstItem={false}
    />
  );
};
